import { ReactNode } from 'react';

export function UnderlinedText({ children }: { children: ReactNode }) {
  return (
    <span className="before:bg-orange relative inline-block before:absolute before:right-0 before:bottom-1 before:left-1 before:-z-10 before:h-1 before:rounded-full lg:before:bottom-2">
      {children}
    </span>
  );
}
